import { useMemo } from 'react';
import useGetExternalProperty from './useGetExternalProperty';

/**
 * Properties needed to resolve custom-field template variables. External values
 * only carry `externalPropertyId`, so `replaceAllTemplateVariables` needs the
 * property list to know a variable's name, valueType and options.
 *
 * Deliberately unfiltered (every table type): a template may mix account and
 * contact variables. Sharing one query string across all substitution sites
 * keeps them on a single cached entry.
 */
export default function useGetTemplateVariableExternalProperties() {
  const { data } = useGetExternalProperty({ tableType: null });

  return useMemo(() => data?.data?.data ?? null, [data]);
}

/**
 * Whether the query behind `useGetTemplateVariableExternalProperties` is still
 * on its first fetch, for callers that must hold off substitution until the
 * properties are in: the list alone cannot tell a request in flight from one
 * that errored or resolved to nothing.
 */
export function useIsTemplateVariableExternalPropertiesLoading() {
  const { isInitialLoading } = useGetExternalProperty({ tableType: null });

  return isInitialLoading;
}
